import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=26fc1948&"
import script from "./Table.vue?vue&type=script&lang=js&"
export * from "./Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26fc1948')) {
      api.createRecord('26fc1948', component.options)
    } else {
      api.reload('26fc1948', component.options)
    }
    module.hot.accept("./Table.vue?vue&type=template&id=26fc1948&", function () {
      api.rerender('26fc1948', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/components/Table.vue"
export default component.exports